import { Alert, Card, CardGroup, Icon } from '@ver-uds/uswds-react';
import React from 'react';
import { Button, FieldGroup } from '@ver-uds/react';
import { displayTextForName, displayTextForPhoneNumber } from '../../../utils/dashboardUtils';
import './DashboardUserProfileCard.scss';
import { useDashboard } from '../../../context/Dashboard/DashboardContext';
import { defaultFieldValue } from '../../../constants/Dashboard';

export type DashboardUserProfileCardProps = {
  onEditClicked: () => void;
};

const DashboardUserProfileCard = ({ onEditClicked }: DashboardUserProfileCardProps): JSX.Element => {
  const { profile, hasProfileError } = useDashboard();

  return (
    <CardGroup>
      <Card className="user-profile-card">
        <Card.Body>
          <div className="grid-row user-profile-card-header">
            <h2 className="grid-row user-profile-title-container">
              <Icon name="account_circle" className="user-profile-icon" />
              <div>User Profile</div>
            </h2>
            <Button
              variant="tertiary"
              className="user-edit-button"
              iconLeft={<Icon name="edit" className="user-edit-icon" />}
              onClick={onEditClicked}
            >
              Edit
            </Button>
          </div>
          {hasProfileError && (
            <Alert status="warning" slim className="margin-top-3 margin-bottom-3">
              <Alert.Text>User profile information could not be displayed at this time.</Alert.Text>
            </Alert>
          )}
          <FieldGroup className="grid-row">
            <FieldGroup.Field name="Name" className="desktop:grid-col-4 tablet:grid-col-6 mobile:grid-col-12">
              {displayTextForName(profile?.firstName, profile?.lastName, profile?.middleInitial)}
            </FieldGroup.Field>
            <FieldGroup.Field name="Email Address" className="desktop:grid-col-4 tablet:grid-col-6 mobile:grid-col-12">
              {profile?.email || defaultFieldValue}
            </FieldGroup.Field>
            <FieldGroup.Field name="Phone Number" className="desktop:grid-col-4 tablet:grid-col-6 mobile:grid-col-12">
              {displayTextForPhoneNumber(profile?.phoneNumber)}
            </FieldGroup.Field>
          </FieldGroup>
        </Card.Body>
      </Card>
    </CardGroup>
  );
};

export default DashboardUserProfileCard;
